import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Checkout from 'checkout/checkout/Checkout';
import HostedPayment from 'checkout/hostedPayment/HostedPayment';
import ForgotPassword from 'checkout/login/ForgotPassword';
import Login from 'checkout/login/Login';
import MagicLink from 'checkout/login/MagicLink';
import PayGate from 'checkout/payGate/PayGate';
import NotFound from 'common/components/layout/404';
import Receipt from 'profile/orderHistory/OrderReceipt';
import { getCart } from 'redux/cart/actions';
import { getCustomer } from 'redux/customer/actions';
// import Violator from 'checkout/violator/Violator';

import CheckoutRoute from './CheckoutRoute';

class CheckoutApp extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('cartId')) {
      props.getCart();
    }
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    return (
      <Switch>
        <CheckoutRoute exact path="/checkout" component={Checkout} />
        <CheckoutRoute exact path="/checkout/login" component={Login} />
        <CheckoutRoute exact path="/checkout/paygate" component={PayGate} />
        <CheckoutRoute
          exact
          path="/checkout/hosted-payment"
          component={HostedPayment}
        />
        <CheckoutRoute
          exact
          path="/checkout/forgot-password"
          component={ForgotPassword}
        />
        <CheckoutRoute
          exact
          path="/checkout/magic-link"
          component={MagicLink}
        />
        <CheckoutRoute exact path="/checkout/checkout" component={Checkout} />
        <Route exact path="/checkout/receipt" component={Receipt} />
        <Route exact path="/checkout/receipt/:orderId" component={Receipt} />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

export default connect(null, { getCustomer, getCart })(CheckoutApp);
